module.exports = __webpack_public_path__ + "img/pos_s1_icon4.6ba84833.png";